import { render, staticRenderFns } from "./AccountTab.vue?vue&type=template&id=6ebdf9fe&scoped=true"
import script from "./AccountTab.vue?vue&type=script&lang=js"
export * from "./AccountTab.vue?vue&type=script&lang=js"
import style0 from "./AccountTab.vue?vue&type=style&index=0&id=6ebdf9fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebdf9fe",
  null
  
)

export default component.exports